import React, { useEffect } from 'react'
import Chart from "chart.js";
import { isValueNullOrUndefinedOrEmpty } from '../../../../common/utility/utility';
import 'chartjs-plugin-datalabels';
import "./DoughnutChart.css";

export default function DoughnutChart(props) {  

    const chartRefInner = React.createRef();  
    const chartRefOuter = React.createRef();  
    const chartType = "doughnut";
    const innerCircleColors = [ "#3A6073",props.innerColor]; 
    const outerCircleColors = [ "#FBFFFF",props.innerColor ]; 

    const getRotation = () => {  
        let value = isInvalidValue(props.reportDetails) ? -110 : props.reportDetails;
        if(value > 100 || value < -100)
        {
            value = value + value > 100 ? -100 : 100;
        } 
        return ((-0.5 * Math.PI) - ((value > 0 ? -value : value)/100  * Math.PI));        
    }

    const isInvalidValue = (input) => {
        return (input < 0 || input > 100 || isValueNullOrUndefinedOrEmpty(input));
    }

    const getDisplayValue = (value, context) => {
        return context.dataIndex === 0 ? "" : isInvalidValue(props.reportDetails) ? "" : value + '%' ;
    }

    const getTitle= () => { 
        return  {
            display: false
        }
    }

    const getPlugins = (showDataLabel) => { 
        return showDataLabel ? 
        {
            datalabels: {
                align: 'center',
                anchor : props.reportDetails === 0 ? 'center' : 'start',
                color: '#25336C',
                font: function(context) {
                    var width = context.chart.width;
                    var size = Math.round(width / 15);
                    return {
                        weight: 'bold',
                        size: size
                    };
                },               
                formatter: (value, context) => getDisplayValue(value, context)
                }            
            } : {
            datalabels: {
                display: false
            }
        }        
    }  

    const getOptions = (cutoutPercentage, showPlugin) => { 
        return { 
            animation: {
                duration: 0
            },
            cutoutPercentage: cutoutPercentage,
            rotation: getRotation(),
            title: getTitle(),
            legend: {
                display: false,              
            },
            responsive: true,
            maintainAspectRatio: false,
            tooltips: {
                enabled: false
            },
            plugins: getPlugins(showPlugin)
        }
    }

    const getData = (colors, borderWidth) => { 
        let topMarginValue = props.reportDetails < 0 ? -100 : 100;
        let value = isInvalidValue(props.reportDetails) ? 0 : props.reportDetails;        
        return {  
            datasets: [                 
            {
                data : [ topMarginValue - value, value ],
                backgroundColor: colors,
                hoverBackgroundColor: colors,
                borderWidth : borderWidth
            }
        ]}
    }
  
    useEffect(() => {

        const myChartRefInner = chartRefInner.current.getContext("2d");
        const myChartRefOuter = chartRefOuter.current.getContext("2d");
        
        new Chart(myChartRefInner, {
            type: chartType,
            data: getData(innerCircleColors),   
            options: getOptions(35, false)
        })

        new Chart(myChartRefOuter, {
            type: chartType,
            data: getData(outerCircleColors, 0),      
            options: getOptions(75, true)
        })
    });

    return (
        <div className="chartjs-render-monitor chart-container">
            <canvas id="myChartInner" ref={chartRefInner} />
            <canvas id="myChartouter" ref={chartRefOuter} />
        </div>
    )    
}
